export const userListingConstants = {    
    GETALLUSERLISTING_REQUEST: 'GETALLUSERLISTING_REQUEST',
    GETALLUSERLISTING_REQUEST_END: 'GETALLUSERLISTING_REQUEST_END',
    GETALLUSERLISTING_SUCCESS: 'GETALLUSERLISTING_SUCCESS',
    GETALLUSERLISTING_FAILURE: 'GETALLUSERLISTING_FAILURE',
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
};
